

import { Link } from "react-router-dom";
import OrderDetails from "../../components/Orders/OrderDetails/Index";
import { Breadcrumb } from "react-bootstrap";

const OrderDetailsPage = () => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h3 className="mb-0">Detalles de la Orden</h3>

        <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
          <Breadcrumb.Item href="/store">
            <div className="d-flex align-items-center text-decoration-none">
              <i className="ri-home-4-line fs-18 text-primary me-1"></i>
              <span className="text-secondary fw-medium hover">Inicio</span>
            </div>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/orders" className="text-decoration-none">
              <span className="fw-medium">Órdenes</span>
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <span className="fw-medium">Detalles de Orden</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <OrderDetails />
    </>
  );
};

export default OrderDetailsPage;
